// extracted by mini-css-extract-plugin
export default {"spinner":"Spinner_spinner__tMf-p","load6":"Spinner_load6__dERf5","round":"Spinner_round__JQCEk"};